import { createAction } from 'redux-actions';

import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  RESET_LOGIN_STATUS,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  CHECK_LOCAL_AUTH,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
} from './type';

//Login
export const loginAction = createAction(LOGIN);
export const loginSuccessAction = createAction(LOGIN_SUCCESS);
export const loginErrorAction = createAction(LOGIN_ERROR);
export const resetLoginStatusAction = createAction(RESET_LOGIN_STATUS);

//Logout
export const logoutAction = createAction(LOGOUT);
export const logoutSuccessAction = createAction(LOGOUT_SUCCESS);
export const logoutErrorAction = createAction(LOGOUT_ERROR);

//Check LocalAuth
export const checkLocalAuth = createAction(CHECK_LOCAL_AUTH);

//Reset password
export const resetPasswordAction = createAction(RESET_PASSWORD);
export const resetPasswordSuccessAction = createAction(RESET_PASSWORD_SUCCESS);
export const resetPasswordErrorAction = createAction(RESET_PASSWORD_ERROR);

//forgot password
export const forgotPasswordAction = createAction(FORGOT_PASSWORD);
export const forgotPasswordSuccessAction = createAction(
  FORGOT_PASSWORD_SUCCESS,
);
export const forgotPasswordErrorAction = createAction(FORGOT_PASSWORD_ERROR);

//verify code
export const verifyCodeAction = createAction(VERIFY_CODE);
export const verifyCodeSuccessAction = createAction(VERIFY_CODE_SUCCESS);
export const verifyCodeErrorAction = createAction(VERIFY_CODE_ERROR);

//verify code
export const changePasswordAction = createAction(CHANGE_PASSWORD);
export const changePasswordSuccessAction = createAction(
  CHANGE_PASSWORD_SUCCESS,
);
export const changePasswordErrorAction = createAction(CHANGE_PASSWORD_ERROR);
